import { Connector } from '../../connector'
import { ProtectRulesQuickFilter } from '../../../components/protect-rules/shared'
import { ContrastQueryParameters } from '../../../graphql/schema/endpoint-helpers'

export interface ProtectRulesQuickFiltersParams {
  readonly q?: string
}

export interface ProtectRulesQuickFiltersQueryArgs
  extends ProtectRulesQuickFiltersParams {
  readonly organizationUuid: string
}

export async function getProtectRulesQuickFilters(
  this: { readonly connector: Connector },
  { organizationUuid, q }: ProtectRulesQuickFiltersQueryArgs
): Promise<ProtectRulesQuickFilter[]> {
  const urlParams = new ContrastQueryParameters()
  if (q) {
    urlParams.append('q', q)
  }

  const params = q ? `?${urlParams}` : ''

  const { filters } = await this.connector.get(
    `/${organizationUuid}/protection/rules/filters/quick${params}`
  )
  return filters
}
